import { Component, OnDestroy } from '@angular/core';
import { OrdersService } from '../../../../services/orders.service';
import { StoreService } from '../../../../services/store.service';
import { ActivatedRoute } from '@angular/router';
import { ID_PARAM } from '../../../../config/url.config';
import { OrderModel } from '../../../../model/order.model';
import { Observable, tap } from 'rxjs';
import { SpanModel } from '../../../../model/span.model';
import { setColumnsDef } from '../../../../modules/data/utils/data.utils';
import { TowerModel } from '../../../../model/tower.model';
import { userOptionLabel } from '../../../../utils/user.utils';
import { UserModel } from '../../../../model/general.model';

@Component({
  selector: 'order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnDestroy {

  orderId!: number;
  order$: Observable<OrderModel>;
  height = '400px';

  constructor(
    private store: StoreService,
    private ordersService: OrdersService,
    private route: ActivatedRoute
  ) {
    this.store.showLoader()
    this.orderId = this.route.snapshot.params[ID_PARAM];
    this.order$ = this.ordersService.getOrderById(this.orderId).pipe(
      tap(() => this.store.hideLoader()),
      tap((order) => this.store.updateSelectedProject(order.project.id))
    );
    this.store.hideProjectSelector();
  }

  setColumns(data: TowerModel[] | SpanModel[]) {
    return setColumnsDef(data)
  }

  ngOnDestroy(): void {
    this.store.showProjectSelector();
  }

  getUser(user: UserModel) {
    return userOptionLabel(user)
  }
}
